module.exports = __webpack_public_path__ + "static/img/hdw7.41868691.png";